import "bootstrap/dist/css/bootstrap.min.css";
import Routter from "../src/router/Routter";
import "./App.css";

function App() {
  return (
    <>
      <div className="App">
        <Routter />
      </div>
    </>
  );
}

export default App;
